/**
 * Decide whether the occurrence drawer should open or close.
 *
 * React Router applies navigations in a transition, so `useParams().id` still
 * points at the complaint on the render where the drawer has already closed.
 * `closing` stays true for that stale id and blocks `show`. It clears once
 * the route id actually changes (list, or a different complaint).
 */
export default function syncOccurrenceDrawer({ id, rows, visible, closing, lastId }) {
  const routeChanged = lastId !== id;
  const stillClosing = routeChanged ? false : Boolean(closing);

  if (!id) {
    return {
      closing: false,
      lastId: id,
      action: visible ? 'hide' : 'idle',
      occurrence: null,
    };
  }

  if (stillClosing) {
    return { closing: true, lastId: id, action: 'idle', occurrence: null };
  }

  const occurrence = rows?.find(row => row._id === id) ?? null;
  return {
    closing: false,
    lastId: id,
    action: occurrence ? 'show' : 'idle',
    occurrence,
  };
}
